import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t mt-16 bg-[color:var(--surface)]" data-testid="site-footer">
      <div className="container-editorial py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src="/logo-badge.jpg"
              alt="ITTV News"
              className="h-14 w-auto rounded-md shadow"
              width="120"
              height="120"
              data-testid="footer-logo"
            />
            <span className="font-serif text-3xl font-bold">ITTV News</span>
          </div>
          <p className="mt-4 text-[color:var(--text-muted)] max-w-md leading-relaxed">
            Independent long-form journalism from a single, obsessive newsroom. Written slowly. Read carefully.
          </p>
          <div className="mt-6 flex gap-3">
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="btn-outline" data-testid="footer-twitter">Twitter</a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="btn-outline" data-testid="footer-instagram">Instagram</a>
          </div>
        </div>
        <div>
          <div className="kicker mb-4">Sections</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/category/world" className="hover-underline">World</Link></li>
            <li><Link to="/category/politics" className="hover-underline">Politics</Link></li>
            <li><Link to="/category/technology" className="hover-underline">Technology</Link></li>
            <li><Link to="/category/culture" className="hover-underline">Culture</Link></li>
            <li><Link to="/category/sports" className="hover-underline">Sports</Link></li>
            <li><Link to="/category/celebrities" className="hover-underline">Celebrities</Link></li>
            <li><Link to="/category/dignitaries" className="hover-underline">Dignitaries</Link></li>
            <li><Link to="/category/opinion" className="hover-underline">Opinion</Link></li>
          </ul>
        </div>
        <div>
          <div className="kicker mb-4">ITTV News</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/subscribe" className="hover-underline text-[color:var(--accent)] font-semibold">Subscribe · $5/mo</Link></li>
            <li><Link to="/about" className="hover-underline">About the editor</Link></li>
            <li><Link to="/videos" className="hover-underline">Video & audio</Link></li>
            <li><Link to="/login" className="hover-underline">Contributor login</Link></li>
            <li><a href="mailto:editor@ittvnews.com" className="hover-underline">editor@ittvnews.com</a></li>
            <li><a href="/api/rss.xml" className="hover-underline">RSS feed</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t" style={{ borderColor: "hsl(var(--border-hsl))" }}>
        <div className="container-editorial py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-xs text-[color:var(--text-muted)]">
          <span>© {year} ITTV News. All rights reserved.</span>
          <span className="kicker">Made with rigor · Not with algorithms</span>
        </div>
      </div>
    </footer>
  );
}
